import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHHospitalGet } from "services/services-mia/RNHHospitalGet";
import { RNHHospitalDel } from "services/services-mia/RNHHospitalDel";

export default function DeleteModal({ user, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();

    const formikRef = useRef();

    const getData = async () => {
        setIsLoading(true);
        const result = await RNHHospitalGet(credentials, { id: user.id })
        formikRef.current.setValues({
            id: result[0].rnhHospitalId,
            name: result[0].rnhHospitalNombre,
        });
        setData(result[0]);
        setIsLoading(false);
    }

    const handleDeleteHospital = async (values) => {
        const response = await RNHHospitalDel(
            credentials,
            { id: data.rnhHospitalId }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Hospital eliminado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} })
            closeModal();
        }
    }

    useEffect(() => {
        getData()
    }, []);

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                name: "",
            }}
            validationSchema={
                yup.object({
                    name: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                })
            }
            onSubmit={(values) => {
                handleDeleteHospital(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            name="name"
                            placeholder=""
                            labelText="Nombre de Hospital"
                            disabled={true}
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
